import { Observable } from 'rxjs'
import AxiosSubscriber from '../../factory/AxiosSubscriber'

export class UnlockOrderAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(orderId, next, complete, error) {
    const token = localStorage.getItem('token')
    const httpConfig = {
      url: `/order/${orderId}/unlock-order`,
      method: 'put',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig)
    })

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error,
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}
